// MUI default spacing is 8px
export const spacing = 8;

// Common spacing values
export const spacingValues = {
  xs: spacing * 0.5,  // 4px
  sm: spacing * 1,    // 8px
  md: spacing * 2,    // 16px
  lg: spacing * 3,    // 24px
  xl: spacing * 4,    // 32px
  xxl: spacing * 5,   // 40px
};